// extracted by mini-css-extract-plugin
export default {"footer_bar":"Footer_footer_bar__z5o4H","footer_text":"Footer_footer_text__HX7YO","copyright":"Footer_copyright__AoReg","email":"Footer_email__NZOw+"};